if (!customElements.get('value-props')) {
  class ValueProps extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      gsap.registerPlugin(SplitText);

      let split, animation;
      const targets = gsap.utils.toArray(".value-props-line");
      let tl = gsap.timeline();

      const target = document.querySelector(".value-props");
      const bee = document.querySelector(".bee");

      if (target) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "class"
            ) {
              const el = mutation.target;

              if (!el.classList.contains("scroll-trigger--offscreen")) {
                targets.forEach((target) => {
                  let SplitClient = new SplitText(target, {
                    type: "chars, words",
                    mask: "chars",
                    wordsClass: "single-word",
                  });
                  let chars = SplitClient.chars;
                  tl.from(chars, {
                    duration: 0.05,
                    opacity: 0,
                    delay: 0.150,
                    y: 10,
                    ease: "none",
                    stagger: 0.0150,
                  });
                });
                observer.disconnect();
              }
            }
          });
        });

        observer.observe(target, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }

      // this.window.addEventListener("resize", setup);
    }
  }

  customElements.define('value-props', ValueProps);
}
